/**
 * Imports jQuery.
 *
 * @see http://api.jquery.com/
 *
 * @since 1.0.0
 */
import $ from 'jquery';
import * as helpers from '../global/helpers';
import { els } from './variables';
/* eslint prefer-destructuring: 0 */
let offsetHeight;
if (els.stickySection) {
	offsetHeight = els.stickySection.offsetHeight;
} else {
	offsetHeight = els.header.offsetHeight;
}

/**
 * Surgeon Locator select field functions.
 *
 * @since 1.0.0
 */
$(document).on(
	'change',
	'.surgeon-filter',
	() => {
		const key = Object.keys(window.emlLocators)[0];
		const locator = window.emlLocators[key];
		locator.getLocations(locator.currentPosition.lat, locator.currentPosition.lng);
	},
);


$(document).on(
	'input',
	'.js-eml-search',
	() => {
		helpers.scrollToEl($('.js-eml-search'), offsetHeight);
	},
);

window.addEventListener(
	'emlPreFetchLocations',
	(e) => {
		const url = e.detail.apiUrl;
		const queryString = url.substring(url.indexOf('?') + 1);
		const procValue = $('#specialty-select').val();
		if (queryString) {
			if (procValue !== 'all') {
				e.detail.apiUrl += ` & specialty = ${procValue}`;
			}
		} else if (procValue !== 'all') {
			e.detail.apiUrl += ` ? specialty = ${procValue}`;
		}
	},
);
